export const VossDiscountAutomaticApplicationKind = {
    Never: 0,
    ForNewPurchases: 1
}

export const VossDiscountAutomaticApplicationKindText = {
    [VossDiscountAutomaticApplicationKind.Never]: 'vossDiscountAutomaticApplicationKind.never',
    [VossDiscountAutomaticApplicationKind.ForNewPurchases]: 'vossDiscountAutomaticApplicationKind.forNewPurchases'
}